import { Color } from "../model/color";

export class StatusColorMapper {
    static getStatusColor(status: string): Color {
        switch(status) {
            case 'DATA_ENTERED': return new Color(244, 67, 54);
            case 'READY': return new Color(30, 200, 30);
            case 'INFO_IN_PROGRESS': return new Color(0, 0, 255);
            case 'INFO_PROBLEM': return new Color(255, 0, 0);
            case 'INFO_READY': return new Color(0, 255, 0);
            case 'INFO_SUCCESS': return new Color(0, 0, 0);
            case 'INFO_MAIL': return new Color(0, 255, 0);
            default: return new Color(0, 0, 0);
        }
    }
}
